import React, { useEffect, useRef, useState } from 'react';
import { Config } from '../../API/config';
import axios from 'axios';
import { Category } from '../../types/categoreies';

const CategoriesSection = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [categories, setCategories] = useState<Category[]>([]);
    const [error, setError] = useState<string | null>(null);

    // Fetch categories on component mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const { data } = await axios.get(Config.getAllCategories, {
                    withCredentials: true,
                });
                if (data.statusCode === 200) {
                    setCategories(data.data);
                }
            } catch (err) {
                console.error('Error fetching categories:', err);
                setError('Failed to load categories');
            } finally {
                setIsLoading(false);
            }
        };

        fetchCategories();
    }, []);

    return (
        <div className="bg-gradient-to-r from-categoriesSectionLeft to-categoriesSectionRight text-white py-10 px-5 rounded-lg">
            <div className="max-w-5xl mx-auto">
                {/* Section Title */}
                <div className="flex flex-row-reverse justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold">الفئات المتاحة</h2>
                </div>

                {/* Categories List */}
                {isLoading ? (
                    <div className="text-center">جارٍ التحميل...</div>
                ) : error ? (
                    <div className="text-center text-red-400">{error}</div>
                ) : categories.length === 0 ? (
                    <div className="text-center">لا توجد فئات متاحة</div>
                ) : (
                    <div className="flex flex-wrap gap-3 justify-center md:justify-start text-center">
                        {categories.map((category, index) => (
                            <button
                                key={category._id || index}
                                className="border border-gray-500 rounded-full px-4 py-2 text-sm hover:bg-primary-500 hover:text-white transition duration-300"
                            >
                                {category.name}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CategoriesSection;